
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire839f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire839f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1in20", function(module, exports) {

$parcel$export(module.exports, "applySwUpdate", function () { return $541b3b75bb621a31$export$904a99d8834d6296; });
/**
 * SW + Cache cleanup + in-app update detection.
 *
 * Previous version did an auto window.location.reload() the moment a new
 * service worker activated. On iOS Safari that frequently happened while
 * the user was mid-scroll / mid-form and they'd lose their place — or,
 * worse, the message never arrived (Safari pauses SW chatter in the
 * background) and the user had to force-quit Safari to see new code.
 *
 * v10.25 rewires this to a user-facing pattern:
 *   1. On load, register the SW and start a periodic update probe
 *      (every 60s while the tab is foregrounded).
 *   2. When a new SW reaches `waiting` state, dispatch a custom DOM
 *      event `taki:sw-update-available`. The UpdateBanner component
 *      listens for that event and shows a single-tap refresh button.
 *   3. When the user taps the button, we postMessage SKIP_WAITING to
 *      the waiting worker. The browser fires `controllerchange`, which
 *      we use as the canonical "the new worker is in charge" signal,
 *      and only THEN do we reload — once.
 *
 * This means the user never leaves the app to get the latest build; a
 * banner appears, they tap "تحديث الآن", the page swaps in place. No
 * Safari restart required.
 */ const $541b3b75bb621a31$var$CONTROLLER_CHANGE_RELOADED = 'TAKI_SW_RELOADED_v10_25';
const $541b3b75bb621a31$var$UPDATE_EVENT = 'taki:sw-update-available';
function $541b3b75bb621a31$var$dispatchUpdateAvailable() {
    try {
        window.dispatchEvent(new CustomEvent($541b3b75bb621a31$var$UPDATE_EVENT));
    } catch  {
        // Older browsers — CustomEvent constructor missing. Fall back to
        // legacy Event so the banner still hears about it.
        const ev = document.createEvent('Event');
        ev.initEvent($541b3b75bb621a31$var$UPDATE_EVENT, true, true);
        window.dispatchEvent(ev);
    }
}
const $541b3b75bb621a31$var$VERSION_KEY = 'TAKI_SW_VERSION_SEEN';
const $541b3b75bb621a31$var$AUTO_APPLIED_KEY = 'TAKI_SW_AUTO_APPLIED_AT';
/**
 * Compare the CACHE_NAME baked into the live /sw.js against the last one
 * we observed on this device. If the server advanced (new deploy) and we
 * haven't auto-applied within the last 60 seconds, just nuke the cache
 * and reload — no banner, no waiting on iOS Safari's lazy SW-update
 * scheduling. This is the path that makes "I deployed but the user is
 * still on the old version" stop happening.
 */ let $541b3b75bb621a31$var$_lastVersionCheck = 0;
async function $541b3b75bb621a31$var$autoCheckServerVersion() {
    // Throttle: foreground events (visibilitychange/pageshow/focus) can
    // fire in bursts on iOS — one network probe per 15s is plenty.
    if (Date.now() - $541b3b75bb621a31$var$_lastVersionCheck < 15000) return;
    $541b3b75bb621a31$var$_lastVersionCheck = Date.now();
    try {
        // Force a network fetch — we have to bypass the SW for THIS one
        // request, otherwise the stale SW happily returns its cached
        // copy of /sw.js and we never detect the drift.
        const res = await fetch('/sw.js?_v=' + Date.now(), {
            cache: 'no-store'
        });
        if (!res.ok) return;
        const text = await res.text();
        const match = /taki-cache-v[\d.]+/.exec(text);
        if (!match) return;
        const serverVersion = match[0];
        let lastSeen = null;
        try {
            lastSeen = localStorage.getItem($541b3b75bb621a31$var$VERSION_KEY);
        } catch  {}
        if (!lastSeen) {
            try {
                localStorage.setItem($541b3b75bb621a31$var$VERSION_KEY, serverVersion);
            } catch  {}
            return;
        }
        if (lastSeen === serverVersion) return;
        // Different version on the server. Throttle to one auto-apply per
        // 60 s so a momentary glitch can't loop us.
        let appliedAt = 0;
        try {
            appliedAt = Number(localStorage.getItem($541b3b75bb621a31$var$AUTO_APPLIED_KEY) || '0');
        } catch  {}
        if (Date.now() - appliedAt < 60000) return;
        try {
            localStorage.setItem($541b3b75bb621a31$var$VERSION_KEY, serverVersion);
            localStorage.setItem($541b3b75bb621a31$var$AUTO_APPLIED_KEY, String(Date.now()));
        } catch  {}
        // Apply without any UI — by the time the user notices the page
        // already came back with the new build. The banner stays as a
        // fallback path for cases where this fetch fails.
        $541b3b75bb621a31$export$904a99d8834d6296();
    } catch  {}
}

(async ()=>{
    if (typeof window === 'undefined') return;
    // Kick the version probe immediately. It runs in parallel with the
    // rest of the SW wiring below.
    $541b3b75bb621a31$var$autoCheckServerVersion();
    // CRITICAL for iOS standalone PWAs: when the user "reopens" the app
    // iOS resumes it from memory/bfcache WITHOUT re-running this module
    // or doing a fresh navigation — so the cold-start probe above never
    // fires again and the device stays frozen on an old build no matter
    // how many times they reopen. Re-checking the server's sw.js version
    // every time the app returns to the foreground is what actually
    // delivers new deploys to iOS PWA users (throttled to 1/15s inside).
    const onForeground = ()=>{
        if (document.visibilityState !== 'hidden') $541b3b75bb621a31$var$autoCheckServerVersion();
    };
    document.addEventListener('visibilitychange', onForeground);
    window.addEventListener('pageshow', onForeground);
    window.addEventListener('focus', onForeground);
    if ('serviceWorker' in navigator) {
        // Reload exactly once when the new worker takes control. This is the
        // canonical hook — fires after SKIP_WAITING resolves.
        navigator.serviceWorker.addEventListener('controllerchange', ()=>{
            if (sessionStorage.getItem($541b3b75bb621a31$var$CONTROLLER_CHANGE_RELOADED)) return;
            try {
                sessionStorage.setItem($541b3b75bb621a31$var$CONTROLLER_CHANGE_RELOADED, '1');
            } catch  {}
            window.location.reload();
        });
        // The v10+ SW also posts TAKI_SW_UPDATED on its `activate` handler.
        // Treat it as an additional signal that an update is ready — useful
        // when the page never sees `waiting` (e.g. first install, or a
        // background tab where the new SW skipped straight to active).
        navigator.serviceWorker.addEventListener('message', (event)=>{
            if (event?.data?.type === 'TAKI_SW_UPDATED') $541b3b75bb621a31$var$dispatchUpdateAvailable();
        });
        // Try to attach to whatever SW is currently registered for /. If a
        // new SW is already waiting (e.g. user kept the tab open across two
        // deploys), surface the banner immediately.
        try {
            // v14.13 — تسجيل عامل الخدمة هنا، **مفصولاً تماماً عن إذن الإشعارات**.
            // 🪤 كان التسجيل يقع داخل `pushService` وحده، فكان الحصول على
            // التخزين دون اتصال وبانر التحديث مشروطاً بأن يطلب التطبيق إذن
            // الإشعارات لحظة الفتح — مقابل لا شيء يراه المستخدم. اليوم: العامل
            // يُسجَّل دائماً، والإذن لا يُطلب إلا بزرٍّ صريح بعد أول حجز ناجح.
            let reg = await navigator.serviceWorker.getRegistration('/');
            if (!reg) // العنوان عبر `import.meta.url` شرطُ Parcel لتجميع العامل صحيحاً.
            reg = await navigator.serviceWorker.register((parcelRequire("bsBRQ"))).catch(()=>undefined);
            if (reg) {
                // Immediate update probe on mount — iOS Safari otherwise
                // waits up to 24 h before checking sw.js on its own. This
                // is a no-op if the worker is already current.
                reg.update().catch(()=>{});
                if (reg.waiting) $541b3b75bb621a31$var$dispatchUpdateAvailable();
                reg.addEventListener('updatefound', ()=>{
                    const installing = reg.installing;
                    if (!installing) return;
                    installing.addEventListener('statechange', ()=>{
                        // installed + an active controller already exists =
                        // we just got a NEW worker for an existing site.
                        if (installing.state === 'installed' && navigator.serviceWorker.controller) $541b3b75bb621a31$var$dispatchUpdateAvailable();
                    });
                });
                // Foreground polling: every 60s while visible, ask the SW
                // host for a fresh sw.js. iOS Safari sometimes delays this
                // check on its own; nudging keeps the banner timely.
                const probe = ()=>{
                    if (document.visibilityState === 'visible') reg.update().catch(()=>{});
                };
                setInterval(probe, 60000);
                document.addEventListener('visibilitychange', ()=>{
                    if (document.visibilityState === 'visible') probe();
                });
            }
        } catch  {}
        // Defensive: unregister legacy non-/sw.js workers (pre-v10).
        try {
            const regs = await navigator.serviceWorker.getRegistrations();
            for (const r of regs){
                const scriptUrl = r.active?.scriptURL || r.installing?.scriptURL || r.waiting?.scriptURL || '';
                const isOurNewSW = scriptUrl.endsWith('/sw.js') || /\/sw\.[a-f0-9]+\.js$/.test(scriptUrl);
                if (!isOurNewSW) await r.unregister().catch(()=>{});
            }
        } catch  {}
    }
    // Wipe ancient CacheStorage entries (pre-v10). The new SW manages its
    // own cache namespace; anything outside it is dead weight.
    if ('caches' in window) try {
        const keys = await caches.keys();
        const stale = keys.filter((k)=>!k.includes('v10'));
        if (stale.length > 0) await Promise.all(stale.map((k)=>caches.delete(k).catch(()=>false)));
    } catch  {}
})();
async function $541b3b75bb621a31$export$904a99d8834d6296() {
    try {
        if ('serviceWorker' in navigator) {
            const reg = await navigator.serviceWorker.getRegistration('/');
            if (reg?.waiting) reg.waiting.postMessage({
                type: 'SKIP_WAITING'
            });
        }
    } catch  {}
    if ('caches' in window) try {
        const keys = await caches.keys();
        await Promise.all(keys.map((k)=>caches.delete(k).catch(()=>false)));
    } catch  {}
    // Bypass the bfcache so the next paint actually hits the network.
    // Some iOS Safari versions still serve from cache on reload() — using
    // location.replace with a cache-busted URL is the strongest signal.
    try {
        const u = new URL(window.location.href);
        u.searchParams.set('_taki_r', String(Date.now()));
        window.location.replace(u.toString());
    } catch  {
        window.location.reload();
    }
}

});
parcelRegister("bsBRQ", function(module, exports) {
module.exports = $parcel$resolve("f5Bbd");

});


var $5d5a0b6e07855cd3$exports = {};
$parcel$extendImportMap({
    "f5Bbd": "sw.js"
});


parcelRequire("1in20");

//# sourceMappingURL=path0.fecec168.js.map
